module.exports = __webpack_public_path__ + "static/media/logo.edb6a5b6.png";